import React from 'react';

import { Box } from '@opendoor/bricks/core';

import { getPreClosingOffer, useOfferContext } from 'sellDirect/OfferContext';
import { InternalLink } from 'platform/react-router';
import { getHubSSVAUploadRoute } from 'shared/helpers/routes';

//storybook-check-ignore
/** Renders seller's CTA beneath the seller tasks in selling module. */
export const SellerTasksAction: React.FC = () => {
  const { offer } = useOfferContext();

  const preClosingOffer = getPreClosingOffer(offer);

  if (!preClosingOffer || preClosingOffer.isExpired) {
    return null;
  }

  if (preClosingOffer.ssvaData.ssvaState === 'completed') {
    return (
      <Box py="4">
        <InternalLink
          analyticsName="cake-overview-view-completed-tasks"
          to={getHubSSVAUploadRoute()}
          aria-label={null}
          fontWeight="semibold"
        >
          View completed tasks
        </InternalLink>
      </Box>
    );
  }

  return null;
};
